import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    mainRoot: {
        backgroundColor: "white",
        padding: "6px",
        borderRadius: "0 12px 12px 12px",
        transition: "all 0.3s",
        display: "flex",
        flexDirection: "row",
        "&:hover": {
            boxShadow: "rgb(0 0 0 / 9%) 0px 25px 20px -20px",
            transition: "all 0.3s",
        },
    },
    root: {
        padding: "4px 16px",
        backgroundColor: theme.palette.grey.grey,
        overflowX: "hidden",
        overflowY: "auto",
        boxShadow: "inset 0px 0px 16px 0px rgba(0,0,0,0.1)",
        borderRadius: "0 8px 8px 8px",
        display: "flex",
        alignItems: "flex-start",
        flex: 1,
        position: "relative",   
    },
    attributeValuesRoot: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: "45px",
        width: "100%",
    },
    attributeValuesNoData: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    rootNoAttribute: {
        backgroundColor: theme.palette.grey.grey100,
        height: "260px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    noAttributeText: {
        fontWeight: 600,
        color: theme.palette.grey.grey400,
        fontSize: "18px",
    },
    noAttributeImg: {
        width: "42px",
        marginBottom: "15px",
    },
    attributeItemWrapper: {
        display: "flex",
        flexDirection: "row",
        margin: "5px",
        borderRadius: "12px",
        width: "100%",
    },
    attributeItemLabel: {
        backgroundColor: theme.palette.primary.primary200,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "1rem",
        padding: "5px 0 5px 13px",
        borderRadius: "12px 0 0 12px",
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
        flex: "0 1 auto",
    },
    attributeItemLabelDossier: {
        backgroundColor: "#EBFAEE",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "1rem",
        padding: "5px 0 5px 13px",
        borderRadius: "12px 0 0 12px",
    },
    attributeName: {
        fontSize: "14px",
        color: "#373534",
        fontWeight: 700,
        fontFamily: "Inter",
        padding: "2px 13px 2px 0px",
    },
    attributeNameDossier: {
        fontSize: "14px",
        color: "#373534",
        fontWeight: 700,
        fontFamily: "Inter",
        padding: "2px 13px",
        flex: 1,
    },
    attributeItemValues: {
        padding: ".1rem .8rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: "0 12px 12px 0",
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
    },
    attributeItemImg:{
        position: "relative",
        top: "2px",
    },
    breakWord:{
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineClamp: 1,
        boxOrient: "vertical",
        wordBreak: "break-all",
        whiteSpace: "nowrap",
    },
    attributeItemDate: {
        padding: "6px",
        minWidth: "97px",
        display: "flex",
        gap: "5px",
        border: "1px solid " + theme.palette.grey.grey100,
        borderRadius: "16px",
        position: 'absolute',
        right: "8px", top: "17px",
        backgroundColor: "white",
    },
    attributeItemDateDossier: {
        padding: ".5rem 1rem",
        backgroundColor: theme.palette.primary.primary100,
        minWidth: "97px",
    },
    attributeItemDateModifyLabel: {
        color: theme.palette.error.error600,
        fontSize: "12px",
        fontWeight: 700,
    },
    attributeItemDateModifyDate: {
        color: theme.palette.grey.grey700,
        fontSize: "12px",
        fontWeight: 400,
    },
    attributeDateIcon: {
        width: "15px",
    },
    shownValues:{
        fontSize: "12px",
        color:  theme.palette.black.dark,
        display: "flex",
        alignItems: "center",
        flex: 1,
        minWidth: 0,
    },
    noDataRootDossier: {
        backgroundColor: "white",
        padding: "12px",
        borderRadius: "0 12px 12px 12px",
    },
    noDataRootThird: {
        backgroundColor: "white",
        padding: "12px",
        marginRight: "16px",
        borderRadius: "0 12px 12px 12px",
    },
    attributesItemColor: {
        width: "22px",
        height: "22px",
        border: "1px solid white",
        borderRadius: "4px",
        marginRight: "6px",
        flex: "0 0 auto",
    },
    attributeItemValuesEdit: {
        marginLeft: "4px",
    },
    placeholderValue: {
        color: "#9A9AAF",
        fontSize: '14px',
        whiteSpace: "nowrap",
    },
    wrapWord: {
        wordWrap: "break-word",
        whiteSpace: "normal",
        overflowWrap: "break-word",
        wordBreak: "break-word",
    }
}));

export default useStyles;
